import React, {Component} from 'react';

class Result extends Component {
    constructor(props) {
        super(props);
    }

    onClose() {
        window.WeixinJSBridge.call('closeWindow');
    }

    render() {
        return (
            <div className="page msg_warn js_show">
                <div className="weui-msg">
                    <div className="weui-msg__icon-area"><i className={this.props.msg.result ? 'weui-icon_msg weui-icon-success' : 'weui-icon_msg weui-icon-warn'}></i></div>
                    <div className="weui-msg__text-area">
                        <h2 className="weui-msg__title">{this.props.msg.result ? '操作成功' : '操作失败'}</h2>
                        <p className="weui-msg__desc">{this.props.msg.error}</p>
                    </div>
                    <div className="weui-msg__opr-area">
                        <p className="weui-btn-area">
                            <a id="btn" onClick={this.onClose} className={this.props.msg.result ? 'weui-btn weui-btn_primary' : 'weui-btn weui-btn_default'}>确定</a>
                        </p>
                    </div>
                    <div className="weui-msg__extra-area">
                        <div className="weui-footer">
                            <p className="weui-footer__text">Copyright © 2017 SZZHT</p>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Result;



// WEBPACK FOOTER //
// ./src/result.js